<script>
export default {
  methods: {
    navigateToScreen(screen) {
      return this.$router.push({ name: screen })
    },
  },
}
</script>
